module.exports = __webpack_public_path__ + "img/card_home3.ea53814e.svg";